import ErrorSideBarContent from './ErrorSideBarContent';

export default ErrorSideBarContent;
